<div class="progress__container">
  <svg width="60" height="60" viewBox="0 0 120 120" class="progress__svg">
    <circle
      cx="60"
      cy="60"
      stroke-width="8"
      [attr.r]="radius"
      [ngClass]="getBackgroundColor(value)"
    ></circle>

    <circle
      cx="60"
      cy="60"
      fill="transparent"
      stroke-width="8"
      [attr.r]="radius"
      [style.strokeDasharray]="circumference"
      [style.strokeDashoffset]="dashoffset"
      [ngClass]="getProgressColor(value)"
    ></circle>
  </svg>

  <div
    [ngClass]="{
      'progress__label-compact': mode === 'compact',
      'progress__label-header': mode === 'header'
    }"
    class="progress__label"
  >
    {{ value }}%
  </div>
</div>
